import { render, staticRenderFns } from "./videoDetails.vue?vue&type=template&id=7ebd2ac7&scoped=true&"
import script from "./videoDetails.vue?vue&type=script&lang=js&"
export * from "./videoDetails.vue?vue&type=script&lang=js&"
import style0 from "./videoDetails.vue?vue&type=style&index=0&id=7ebd2ac7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebd2ac7",
  null
  
)

export default component.exports